export const QUESTION_NOT_FOUND = 'QUESTION_NOT_FOUND';
export const QUESTION_REQUIRED = 'QUESTION_REQUIRED';
